<div class="step-panel">

  <div class="pg-title">
    Disbursal readiness
    <span class="badge b-g" style="vertical-align:middle;margin-left:8px">Step 12</span>
  </div>
  <div class="pg-sub">
    Pre-disbursal checklist verification. All items must pass before disbursal can proceed.
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" style="padding:40px;text-align:center">
    <div class="spinner-border text-primary" role="status"></div>
    <div style="margin-top:12px;color:#8b949e;font-size:13px">Verifying pre-conditions...</div>
  </div>

  <ng-container *ngIf="!isLoading">
    <div class="g2">
      <!-- CHECKLIST CARD -->
      <div class="card">
        <div class="card-title">
          <div class="ct-bar"></div>
          Pre-disbursal checklist — {{ checklist.length }} items
        </div>
        <div class="cl-item" *ngFor="let item of checklist">
          <div class="cl-icon" [ngClass]="item.passed ? 'cl-ok' : 'cl-pend'">
            {{ item.passed ? '✓' : '!' }}
          </div>
          <span>{{ item.label }}</span>
          <span class="badge" [ngClass]="item.passed ? 'b-g' : 'b-a'" style="margin-left:auto">
            {{ item.passed ? 'Passed' : 'Pending' }}
          </span>
        </div>
      </div>

      <!-- APPLICATION SUMMARY -->
      <div class="card">
        <div class="card-title">
          <div class="ct-bar"></div>
          Application summary
        </div>
        <div class="sum-row">
          <span class="sk">Application status</span>
          <span class="sv">{{ applicationData?.applicationStatus || '—' }}</span>
        </div>
        <div class="sum-row">
          <span class="sk">Requested amount</span>
          <span class="sv">₹{{ applicationData?.requestedAmount || 0 | number }}</span>
        </div>
        <div class="sum-row">
          <span class="sk">Approved amount</span>
          <span class="sv ok">₹{{ applicationData?.approvedAmount || 0 | number }}</span>
        </div>
        <div class="sum-row">
          <span class="sk">Tenure</span>
          <span class="sv">{{ applicationData?.tenureMonths || 0 }} months</span>
        </div>
        <div class="sum-row">
          <span class="sk">Approved by</span>
          <span class="sv">{{ applicationData?.approvedBy || '—' }}</span>
        </div>
        <div class="sum-row">
          <span class="sk">Approval date</span>
          <span class="sv">{{ applicationData?.approvalDate ? (applicationData?.approvalDate | date:'dd MMM yyyy HH:mm') : '—' }}</span>
        </div>
      </div>
    </div>

    <!-- STATUS ALERTS -->
    <div class="alert ok" *ngIf="allChecksPassed && !isAlreadyReady">
      <span style="flex-shrink:0">✓</span>
      <span><strong>All pre-conditions met.</strong> You may proceed to mark this application as Disbursal Ready.</span>
    </div>

    <div class="alert ok" *ngIf="isAlreadyReady">
      <span style="flex-shrink:0">✓</span>
      <span><strong>Application is already marked as Disbursal Ready.</strong> Proceed to the final step.</span>
    </div>

    <div class="alert warn" *ngIf="!allChecksPassed && !isAlreadyReady">
      <span style="flex-shrink:0">⚠</span>
      <span>Some pre-conditions are not met. Please complete all required steps before marking disbursal ready.</span>
    </div>
  </ng-container>

  <!-- NAV -->
  <div class="nav-bar">
    <button class="btn btn-sec" (click)="prev.emit()">← Back</button>
    <button *ngIf="!isAlreadyReady" class="btn btn-ok btn-lg" (click)="markDisbursalReady()"
      [disabled]="!allChecksPassed || isMarking">
      <span *ngIf="!isMarking">Mark Disbursal Ready →</span>
      <span *ngIf="isMarking">Processing...</span>
    </button>
    <button *ngIf="isAlreadyReady" class="btn btn-pri btn-lg" (click)="next.emit()">
      Continue to Disbursal →
    </button>
  </div>

</div>
